import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import { AISidebar, AIInsightCard } from '../components/ai';
import { laSaponariaLocations } from '../utils/locations';
import { exportToCSV } from '../utils/exportCSV';
import { Search, Filter, Download, X, CheckCircle, Clock, Calendar, ArrowUpDown, Gem, Gift, ShoppingBag } from 'lucide-react';
// Mock claims data - Updated with new structure
const mockClaims = [{
  id: 'RC-1001-2026',
  actionType: 'Riscatto',
  method: 'In Sede',
  date: '15/03/2026',
  time: '14:32',
  code: 'SIERO-HA-001',
  reward: 'Siero Acido Ialuronico Multi-Peso',
  diamonds: 50,
  location: 'Milano Centro',
  userId: 'USR-8A3F2',
  status: 'Utilizzato',
  notes: 'Prodotto ritirato presso il negozio.',
  timeline: [{
    status: 'Riscattato',
    date: '15/03/2026 14:32',
    completed: true
  }, {
    status: 'Utilizzato',
    date: '16/03/2026 09:20',
    completed: true
  }]
}, {
  id: 'UT-1002-2026',
  actionType: 'Utilizzo',
  method: 'Online',
  date: '16/03/2026',
  time: '10:15',
  code: 'SOLIDI-KIT-002',
  reward: 'Kit Cosmetici Solidi Zero Waste',
  diamonds: 50,
  location: '',
  userId: 'USR-9B4C1',
  status: 'Utilizzato',
  notes: 'Codice utilizzato per acquisto online.',
  timeline: [{
    status: 'Riscattato',
    date: '16/03/2026 10:15',
    completed: true
  }, {
    status: 'Utilizzato',
    date: '16/03/2026 10:15',
    completed: true
  }]
}, {
  id: 'RC-1003-2026',
  actionType: 'Riscatto',
  method: 'In Sede',
  date: '18/03/2026',
  time: '11:45',
  code: 'CREMA-VISO-003',
  reward: 'Crema Viso Deep Care Anti-Age',
  diamonds: 50,
  location: 'Bologna',
  userId: 'USR-2D5E8',
  status: 'Riscattato',
  notes: 'Premio fisico. Ritiro previsto presso la sede.',
  timeline: [{
    status: 'Riscattato',
    date: '18/03/2026 11:45',
    completed: true
  }, {
    status: 'Utilizzato',
    date: '-',
    completed: false
  }]
}, {
  id: 'UT-1004-2026',
  actionType: 'Utilizzo',
  method: 'In Sede',
  date: '20/03/2026',
  time: '16:20',
  code: 'WORK-005',
  reward: 'Workshop Cosmetici Fai-da-Te',
  diamonds: 100,
  location: 'Pesaro (Sede e Spaccio)',
  userId: 'USR-7F3A9',
  status: 'Utilizzato',
  notes: 'Workshop completato con successo.',
  timeline: [{
    status: 'Riscattato',
    date: '20/03/2026 16:20',
    completed: true
  }, {
    status: 'Utilizzato',
    date: '20/03/2026 18:30',
    completed: true
  }]
}, {
  id: 'UT-1005-2026',
  actionType: 'Utilizzo',
  method: 'Online',
  date: '22/03/2026',
  time: '09:30',
  code: 'VOUCHER-20',
  reward: 'Buono Sconto 20€ su Acquisto',
  diamonds: 40,
  location: '',
  userId: 'USR-1C6D2',
  status: 'Utilizzato',
  notes: 'Codice utilizzato per acquisto online.',
  timeline: [{
    status: 'Riscattato',
    date: '22/03/2026 09:30',
    completed: true
  }, {
    status: 'Utilizzato',
    date: '22/03/2026 14:45',
    completed: true
  }]
}, {
  id: 'RC-1006-2026',
  actionType: 'Riscatto',
  method: 'In Sede',
  date: '25/03/2026',
  time: '15:20',
  code: 'HENNE-004',
  reward: 'Set Hennetica Tinte Vegetali',
  diamonds: 60,
  location: 'Firenze',
  userId: 'USR-3E7B9',
  status: 'Riscattato',
  notes: 'In attesa di ritiro con consulenza colorazione.',
  timeline: [{
    status: 'Riscattato',
    date: '25/03/2026 15:20',
    completed: true
  }, {
    status: 'Utilizzato',
    date: '-',
    completed: false
  }]
}, {
  id: 'UT-1007-2026',
  actionType: 'Utilizzo',
  method: 'In Sede',
  date: '28/03/2026',
  time: '10:15',
  code: 'CORPO-AHA-007',
  reward: 'Crema Corpo AHA Levigante',
  diamonds: 45,
  location: 'Milano Solari',
  userId: 'USR-4F8C3',
  status: 'Utilizzato',
  notes: 'Prodotto ritirato con campioni omaggio.',
  timeline: [{
    status: 'Riscattato',
    date: '28/03/2026 10:15',
    completed: true
  }, {
    status: 'Utilizzato',
    date: '28/03/2026 10:15',
    completed: true
  }]
}, {
  id: 'RC-1008-2026',
  actionType: 'Riscatto',
  method: 'In Sede',
  date: '30/03/2026',
  time: '14:50',
  code: 'SIERO-HA-001',
  reward: 'Siero Acido Ialuronico Multi-Peso',
  diamonds: 50,
  location: 'Roma Cola di Rienzo',
  userId: 'USR-5G9D4',
  status: 'Riscattato',
  notes: 'Premio in attesa di ritiro.',
  timeline: [{
    status: 'Riscattato',
    date: '30/03/2026 14:50',
    completed: true
  }, {
    status: 'Utilizzato',
    date: '-',
    completed: false
  }]
}];
const Claims = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [filteredClaims, setFilteredClaims] = useState(mockClaims);
  const [selectedClaim, setSelectedClaim] = useState<any>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  // Filters
  const [actionFilter, setActionFilter] = useState('Tutti');
  const [methodFilter, setMethodFilter] = useState('Tutti');
  const [locationFilter, setLocationFilter] = useState<string[]>([]);
  const [tempLocationFilter, setTempLocationFilter] = useState<string[]>([]);
  const [isLocationDropdownOpen, setIsLocationDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  // Sorting
  const [sortConfig, setSortConfig] = useState<{
    key: string | null;
    direction: 'asc' | 'desc' | null;
  }>({
    key: null,
    direction: null
  });
  const locationDropdownRef = useRef<HTMLDivElement>(null);
  // Handle URL params for filtering (from notifications)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const filterType = params.get('filter');
    if (filterType === 'riscatti') {
      setActionFilter('Riscatto');
    } else if (filterType === 'utilizzi') {
      setActionFilter('Utilizzo');
    }
  }, [location.search]);
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (locationDropdownRef.current && !locationDropdownRef.current.contains(event.target as Node)) {
        setIsLocationDropdownOpen(false);
        setTempLocationFilter(locationFilter);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [locationFilter]);
  useEffect(() => {
    let result = [...mockClaims];
    if (actionFilter !== 'Tutti') {
      result = result.filter(claim => claim.actionType === actionFilter);
    }
    if (methodFilter !== 'Tutti') {
      result = result.filter(claim => claim.method === methodFilter);
    }
    if (locationFilter.length > 0) {
      result = result.filter(claim => claim.location && locationFilter.includes(claim.location));
    }
    if (searchTerm) {
      result = result.filter(claim => claim.id.toLowerCase().includes(searchTerm.toLowerCase()) || claim.code.toLowerCase().includes(searchTerm.toLowerCase()) || claim.reward.toLowerCase().includes(searchTerm.toLowerCase()));
    }
    // Date filtering
    if (dateFrom) {
      result = result.filter(claim => {
        const [day, month, year] = claim.date.split('/');
        const claimDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        const fromDate = new Date(dateFrom);
        return claimDate >= fromDate;
      });
    }
    if (dateTo) {
      result = result.filter(claim => {
        const [day, month, year] = claim.date.split('/');
        const claimDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        const toDate = new Date(dateTo);
        return claimDate <= toDate;
      });
    }
    // Sorting
    if (sortConfig.key && sortConfig.direction) {
      result.sort((a: any, b: any) => {
        let aValue = a[sortConfig.key!];
        let bValue = b[sortConfig.key!];
        if (sortConfig.key === 'date') {
          const [dayA, monthA, yearA] = a.date.split('/');
          const [dayB, monthB, yearB] = b.date.split('/');
          aValue = new Date(parseInt(yearA), parseInt(monthA) - 1, parseInt(dayA)).getTime();
          bValue = new Date(parseInt(yearB), parseInt(monthB) - 1, parseInt(dayB)).getTime();
        }
        if (aValue < bValue) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    setFilteredClaims(result);
  }, [actionFilter, methodFilter, locationFilter, searchTerm, dateFrom, dateTo, sortConfig]);
  const handleSort = (key: string) => {
    let direction: 'asc' | 'desc' | null = 'asc';
    if (sortConfig.key === key) {
      if (sortConfig.direction === 'asc') {
        direction = 'desc';
      } else if (sortConfig.direction === 'desc') {
        direction = null;
      }
    }
    setSortConfig({
      key: direction ? key : null,
      direction
    });
  };
  const handleRowClick = (claim: any) => {
    setSelectedClaim(claim);
    setIsDrawerOpen(true);
  };
  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setTimeout(() => setSelectedClaim(null), 300);
  };
  const handleExportCSV = () => {
    // Prepare data for CSV export
    const csvData = filteredClaims.map(claim => ({
      'ID Azione': claim.id,
      Azione: claim.actionType,
      Metodo: claim.method,
      Data: claim.date,
      Ora: claim.time,
      Codice: claim.code,
      'Nome Premio': claim.reward,
      Punti: claim.diamonds,
      Sede: claim.location || '-'
    }));
    const headers = ['ID Azione', 'Azione', 'Metodo', 'Data', 'Ora', 'Codice', 'Nome Premio', 'Punti', 'Sede'];
    exportToCSV(csvData, 'GB_Partner.csv', headers);
  };
  const handleLocationToggle = (location: string) => {
    setTempLocationFilter(prev => prev.includes(location) ? prev.filter(l => l !== location) : [...prev, location]);
  };
  const handleApplyLocationFilter = () => {
    setLocationFilter(tempLocationFilter);
    setIsLocationDropdownOpen(false);
  };
  const handleOpenLocationDropdown = () => {
    setTempLocationFilter(locationFilter);
    setIsLocationDropdownOpen(!isLocationDropdownOpen);
  };
  const getActionIcon = (actionType: string) => {
    switch (actionType) {
      case 'Riscatto':
        return <Gift className="h-4 w-4 text-gray-500" data-id="element-947" />;
      case 'Utilizzo':
        return <ShoppingBag className="h-4 w-4 text-gray-500" data-id="element-948" />;
      default:
        return null;
    }
  };
  const SortableHeader = ({
    label,
    sortKey,
    className = ''
  }: {
    label: string;
    sortKey: string;
    className?: string;
  }) => {
    const isSorted = sortConfig.key === sortKey;
    return <th className={`px-4 py-3 cursor-pointer select-none ${className}`} onClick={() => handleSort(sortKey)} data-id="element-949">
        <div className="flex items-center justify-between whitespace-nowrap" data-id="element-950">
          <span data-id="element-951">{label}</span>
          <ArrowUpDown className={`h-3 w-3 ml-1 ${isSorted ? 'text-green-600' : 'text-gray-400'}`} data-id="element-952" />
        </div>
      </th>;
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-953">
      <div className="w-20 flex-shrink-0" data-id="element-954">
        <Sidebar data-id="element-955" />
      </div>
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-956">
        <Topbar data-id="element-957" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-958">
          <PageHeader title="Riscatti e Utilizzi" subtitle="Storico dei premi riscattati e utilizzati (dati pseudonimi)." primaryAction={{
          label: 'Esporta CSV',
          onClick: handleExportCSV,
          icon: <Download className="h-4 w-4 mr-2" data-id="element-960" />
        }} data-id="element-959" />

          {/* Filters */}
          <div className="mb-6 flex flex-wrap gap-3" data-id="element-961">
            <div className="relative" data-id="element-962">
              <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" data-id="element-963" />
              <input type="text" placeholder="Cerca ID azione, codice o premio..." className="rounded-lg border border-gray-300 pl-10 pr-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-greenback" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-964" />
            </div>

            {/* Date From */}
            <div className="flex items-center rounded-lg border border-gray-300 px-3 py-2 gap-2" data-id="element-965">
              <Calendar className="h-4 w-4 text-gray-500" data-id="element-966" />
              <span className="text-sm text-gray-600" data-id="element-967">Da:</span>
              <input type="date" className="bg-transparent text-sm focus:outline-none" value={dateFrom} onChange={e => setDateFrom(e.target.value)} data-id="element-968" />
            </div>

            {/* Date To */}
            <div className="flex items-center rounded-lg border border-gray-300 px-3 py-2 gap-2" data-id="element-969">
              <Calendar className="h-4 w-4 text-gray-500" data-id="element-970" />
              <span className="text-sm text-gray-600" data-id="element-971">A:</span>
              <input type="date" className="bg-transparent text-sm focus:outline-none" value={dateTo} onChange={e => setDateTo(e.target.value)} data-id="element-972" />
            </div>

            {/* Action Filter */}
            <div className="flex items-center rounded-lg border border-gray-300 px-3 py-2" data-id="element-973">
              <Filter className="mr-2 h-4 w-4 text-gray-500" data-id="element-974" />
              <select className="bg-transparent text-sm focus:outline-none" value={actionFilter} onChange={e => setActionFilter(e.target.value)} data-id="element-975">
                <option value="Tutti" data-id="element-976">Tutte le azioni</option>
                <option value="Riscatto" data-id="element-977">Riscatto</option>
                <option value="Utilizzo" data-id="element-978">Utilizzo</option>
              </select>
            </div>

            {/* Method Filter */}
            <div className="flex items-center rounded-lg border border-gray-300 px-3 py-2" data-id="element-979">
              <Filter className="mr-2 h-4 w-4 text-gray-500" data-id="element-980" />
              <select className="bg-transparent text-sm focus:outline-none" value={methodFilter} onChange={e => setMethodFilter(e.target.value)} data-id="element-981">
                <option value="Tutti" data-id="element-982">Tutti i metodi</option>
                <option value="In Sede" data-id="element-983">In Sede</option>
                <option value="Online" data-id="element-984">Online</option>
              </select>
            </div>

            {/* Location Multi-Select */}
            <div className="relative" ref={locationDropdownRef} data-id="element-985">
              <div className="flex items-center rounded-lg border border-gray-300 px-3 py-2 cursor-pointer hover:bg-gray-50" onClick={handleOpenLocationDropdown} data-id="element-986">
                <Filter className={`mr-2 h-4 w-4 ${locationFilter.length > 0 ? 'text-green-600' : 'text-gray-500'}`} data-id="element-987" />
                <span className="text-sm" data-id="element-988">
                  {locationFilter.length === 0 ? 'Tutte le Sedi' : `${locationFilter.length} selezionate`}
                </span>
              </div>

              {isLocationDropdownOpen && <div className="absolute top-full left-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg p-3 z-10 min-w-[220px] max-h-[300px] overflow-y-auto" data-id="element-989">
                  <div className="space-y-2 mb-3" data-id="element-990">
                    {laSaponariaLocations.map(location => <label key={location} className="flex items-center px-2 py-1.5 hover:bg-gray-50 cursor-pointer rounded" data-id="element-991">
                        <input type="checkbox" checked={tempLocationFilter.includes(location)} onChange={() => handleLocationToggle(location)} className="mr-2 accent-green-600" data-id="element-992" />
                        <span className="text-sm" data-id="element-993">{location}</span>
                      </label>)}
                  </div>
                  <button onClick={handleApplyLocationFilter} className="w-full bg-greenback text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-greenback-600 transition-colors" data-id="element-994">
                    Applica filtri
                  </button>
                </div>}
            </div>
          </div>

          {/* Table */}
          <div className="rounded-lg border border-gray-200 bg-white overflow-hidden" data-id="element-995">
            <div className="overflow-x-auto" data-id="element-996">
              <table className="w-full" data-id="element-997">
                <thead data-id="element-998">
                  <tr className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-999">
                    <SortableHeader label="ID Azione" sortKey="id" data-id="element-1000" />
                    <SortableHeader label="Azione" sortKey="actionType" data-id="element-1001" />
                    <SortableHeader label="Metodo" sortKey="method" data-id="element-1002" />
                    <SortableHeader label="Data" sortKey="date" data-id="element-1003" />
                    <SortableHeader label="Ora" sortKey="time" data-id="element-1004" />
                    <SortableHeader label="Codice" sortKey="code" data-id="element-1005" />
                    <SortableHeader label="Nome Premio" sortKey="reward" className="min-w-[160px]" data-id="element-1006" />
                    <SortableHeader label="Punti" sortKey="diamonds" data-id="element-1007" />
                    <SortableHeader label="Sede" sortKey="location" data-id="element-1008" />
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200" data-id="element-1009">
                  {filteredClaims.map(claim => <tr key={claim.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => handleRowClick(claim)} data-id="element-1010">
                      <td className="px-4 py-4" data-id="element-1011">
                        <span className="font-mono text-sm font-medium text-gray-900" data-id="element-1012">
                          {claim.id}
                        </span>
                      </td>
                      <td className="px-4 py-4" data-id="element-1013">
                        <div className="flex items-center gap-2" data-id="element-1014">
                          {getActionIcon(claim.actionType)}
                          <span className="text-sm text-gray-900" data-id="element-1015">
                            {claim.actionType}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-600" data-id="element-1016">
                        {claim.method}
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-600" data-id="element-1017">
                        {claim.date}
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-600" data-id="element-1018">
                        {claim.time}
                      </td>
                      <td className="px-4 py-4" data-id="element-1019">
                        <span className="font-mono text-sm text-gray-700" data-id="element-1020">
                          {claim.code}
                        </span>
                      </td>
                      <td className="px-4 py-4" style={{
                    minWidth: '160px'
                  }} data-id="element-1021">
                        <div className="font-medium text-gray-900" data-id="element-1022">
                          {claim.reward}
                        </div>
                      </td>
                      <td className="px-4 py-4 font-medium" data-id="element-1023">
                        <div className="flex items-center gap-1" data-id="element-1024">
                          <Gem className="h-3.5 w-3.5 text-gray-500" data-id="element-1025" />
                          <span data-id="element-1026">{claim.diamonds}</span>
                        </div>
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-600" data-id="element-1027">
                        {claim.location || '-'}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          {filteredClaims.length === 0 && <div className="text-center py-12 text-gray-500" data-id="element-1028">
              <p data-id="element-1029">
                Nessun riscatto o utilizzo trovato con i filtri selezionati.
              </p>
            </div>}
        </main>
      </div>

      {/* AI Sidebar */}
      <AISidebar data-id="element-1030">
        <AIInsightCard title="AI: Lettura del periodo" insights={['I riscatti aumentano soprattutto su cosmetici solidi zero-waste (+25%).', 'Picco di utilizzi online negli ultimi 7 giorni (+18%).', 'Set Hennetica: calo conversione. Considera riduzione costo a 50 punti.', 'Workshop Cosmetici Fai-da-Te: alta domanda. Aumenta disponibilità del 30%.']} ctaLabel="Apri premi" onCtaClick={() => navigate('/rewards')} lastUpdated="Ultimi 7 giorni" data-id="element-1031" />
      </AISidebar>

      {/* Detail Drawer */}
      {isDrawerOpen && selectedClaim && <>
          <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={handleCloseDrawer} data-id="element-1032"></div>

          <div className={`fixed top-0 right-0 h-full w-full sm:w-[500px] bg-white shadow-xl z-50 overflow-y-auto transition-transform duration-300 ease-in-out ${isDrawerOpen ? 'transform-none' : 'translate-x-full'}`} data-id="element-1033">
            <div className="p-6" data-id="element-1034">
              <div className="flex items-center justify-between mb-6" data-id="element-1035">
                <h2 className="text-xl font-semibold" data-id="element-1036">Dettagli Azione</h2>
                <button onClick={handleCloseDrawer} className="rounded-full p-2 hover:bg-gray-100 transition-colors" data-id="element-1037">
                  <X className="h-5 w-5 text-gray-500" data-id="element-1038" />
                </button>
              </div>

              <div className="space-y-6" data-id="element-1039">
                <div data-id="element-1040">
                  <span className="font-mono text-sm text-gray-500" data-id="element-1041">
                    ID Azione
                  </span>
                  <p className="font-mono text-lg font-semibold mt-1" data-id="element-1042">
                    {selectedClaim.id}
                  </p>
                </div>

                <div data-id="element-1043">
                  <span className="text-sm text-gray-500" data-id="element-1044">Tipo Azione</span>
                  <p className="text-base font-medium mt-1" data-id="element-1045">
                    {selectedClaim.actionType}
                  </p>
                </div>

                <div data-id="element-1046">
                  <span className="text-sm text-gray-500" data-id="element-1047">Metodo</span>
                  <p className="text-base font-medium mt-1" data-id="element-1048">
                    {selectedClaim.method}
                  </p>
                </div>

                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1049">
                  <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-1050">
                    Premio
                  </h3>
                  <p className="font-medium text-gray-900" data-id="element-1051">
                    {selectedClaim.reward}
                  </p>
                  <div className="flex items-center justify-between mt-2 text-sm" data-id="element-1052">
                    <span className="text-gray-500" data-id="element-1053">Codice:</span>
                    <span className="font-mono font-medium" data-id="element-1054">
                      {selectedClaim.code}
                    </span>
                  </div>
                  <div className="flex items-center justify-between mt-1 text-sm" data-id="element-1055">
                    <span className="text-gray-500" data-id="element-1056">Costo:</span>
                    <span className="font-medium flex items-center gap-1" data-id="element-1057">
                      <Gem className="h-3 w-3 text-gray-900" data-id="element-1058" />
                      {selectedClaim.diamonds}
                    </span>
                  </div>
                </div>

                <div data-id="element-1059">
                  <span className="text-sm text-gray-500" data-id="element-1060">Data e Ora</span>
                  <p className="text-base font-medium mt-1" data-id="element-1061">
                    {selectedClaim.date} alle {selectedClaim.time}
                  </p>
                </div>

                {selectedClaim.location && <div data-id="element-1062">
                    <span className="text-sm text-gray-500" data-id="element-1063">Sede</span>
                    <p className="text-base font-medium mt-1" data-id="element-1064">
                      {selectedClaim.location}
                    </p>
                  </div>}

                {/* Timeline */}
                <div data-id="element-1065">
                  <h3 className="text-sm font-medium text-gray-900 mb-4" data-id="element-1066">
                    Timeline
                  </h3>
                  <div className="space-y-4" data-id="element-1067">
                    {selectedClaim.timeline.map((step: any, index: number) => <div key={index} className="flex items-start" data-id="element-1068">
                        <div className="flex flex-col items-center mr-4" data-id="element-1069">
                          {step.completed ? <div className="flex items-center justify-center w-8 h-8 rounded-full bg-green-100" data-id="element-1070">
                              <CheckCircle className="h-5 w-5 text-green-600" data-id="element-1071" />
                            </div> : <div className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-100" data-id="element-1072">
                              <Clock className="h-5 w-5 text-gray-400" data-id="element-1073" />
                            </div>}
                          {index < selectedClaim.timeline.length - 1 && <div className={`w-0.5 h-12 ${step.completed ? 'bg-green-200' : 'bg-gray-200'}`} data-id="element-1074"></div>}
                        </div>
                        <div className="flex-1 pb-4" data-id="element-1075">
                          <p className={`font-medium ${step.completed ? 'text-gray-900' : 'text-gray-400'}`} data-id="element-1076">
                            {step.status}
                          </p>
                          <p className="text-sm text-gray-500 mt-1" data-id="element-1077">
                            {step.date}
                          </p>
                        </div>
                      </div>)}
                  </div>
                </div>

                {/* Notes */}
                <div className="bg-blue-50 rounded-lg p-4 border border-blue-200" data-id="element-1078">
                  <h3 className="text-sm font-medium text-blue-900 mb-2" data-id="element-1079">
                    Note
                  </h3>
                  <p className="text-sm text-blue-800" data-id="element-1080">{selectedClaim.notes}</p>
                </div>
              </div>
            </div>
          </div>
        </>}
    </div>;
};
export default Claims;